<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import LargeTabHeader from "@/components/common/tabs/LargeTabHeader.vue";

export default {
  components: {LargeTabHeader},
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState({
      userSettings: state => state.settings
    }),
    ...mapGetters(['isLocked']),
    isDuplicateCheckValid() {
      return (this.userSettings.duplicateCheckPeriodInDays >= 1 &&
        this.userSettings.duplicateCheckPeriodInDays <= this.userSettings.daysUntilDataCleaning)
    }
  },
  methods: {
    ...mapActions(['saveUserSettings']),
    handleClick() {
      this.loading = true
      this.saveUserSettings({
        duplicateCheckEnabled: this.userSettings.duplicateCheckEnabled,
        duplicateCheckPeriodInDays: this.userSettings.duplicateCheckPeriodInDays
      })
      .then(() => {
        this.$notify(this.$t('notification.save.success'), {type: 'success'})
      })
      .catch(() => {
        this.$notify(this.$t('notification.save.error'), {type: 'error'})
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<template>
  <v-container fluid>
    <!--    HEADER-->
    <LargeTabHeader
      :title="$t('component.documents.document.validation')"
      :subtitle="$t('component.documents.validation.description')"/>

    <v-divider></v-divider>

    <v-row>
      <v-col>
        <v-card flat tile color="transparent">
          <v-card-text>
            <v-container style="width:40vw">
              <v-row>
                <v-col cols="12">
            <span class="headline text-center primary--text">
              {{ $t('component.documents.remove.duplicate') }}
            </span>
                  <v-checkbox
                    id="document-checks-duplicate-checkbox"
                    v-model="userSettings.duplicateCheckEnabled">
                    <template #label>
                <span class="text-body-2 secondary--text">
                  {{ $t('component.documents.duplicate.description') }}
                </span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-if="userSettings.duplicateCheckEnabled"
                    id="document-checks-duplicate-period"
                    v-model="userSettings.duplicateCheckPeriodInDays"
                    :label="$t('component.profile.accountManagement.days')"
                    type="number"
                    :rules="[v => (v >= 1 && v <= userSettings.daysUntilDataCleaning) || $t('component.documentValidation.time.span')]"
                    outlined
                    dense>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              v-if="!isLocked"
              id="save-document-checks-button"
              class="text-center px-8"
              color="primary"
              :loading="loading"
              :disabled="!isDuplicateCheckValid"
              depressed
              @click.stop="handleClick">
              {{ $t('button.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>
